"use client";

import Image from "@/components/Image";
import { useState, useEffect, useRef } from "react";
import styles from "./Campus.module.css";
import Modal from "@/app/components/Modal";
// 定义悬停时显示的图片
const HOVER_IMAGES = {
  section1: ["/paper_05.png"],
  section2: ["/teaching_resources-_05.png"],
  section3: ["/lecture_review_05.jpg"],
  section4: ["/data_analysis_05.png"],
};

const Campus = () => {
  // 状态管理
  const [hoverSection, setHoverSection] = useState<string | null>(null);
  const [onclickSection, setOnclickSection] = useState<string | null>(null);
  const [imageIndex, setImageIndex] = useState(0);
  const autoScrollInterval = useRef<NodeJS.Timeout | null>(null);
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 处理鼠标悬停
  const handleMouseEnter = (section: string) => {
    setHoverSection(section);
    setImageIndex(0); // 重置图片索引

    // 开始自动滚动
    if (autoScrollInterval.current) {
      clearInterval(autoScrollInterval.current);
    }

    autoScrollInterval.current = setInterval(() => {
      setImageIndex((prevIndex) => {
        const images = HOVER_IMAGES[section as keyof typeof HOVER_IMAGES];
        return (prevIndex + 1) % images.length;
      });
    }, 2000); // 每2秒切换一次图片
  };
  // 点击按钮打开弹窗
  const handleOnClick = () => {
    if (document.documentElement.clientWidth <= 660) {
      setIsModalOpen(true);
    }
  };
  // 处理鼠标离开
  const handleMouseLeave = () => {
    setHoverSection(null);

    // 停止自动滚动
    if (autoScrollInterval.current) {
      clearInterval(autoScrollInterval.current);
      autoScrollInterval.current = null;
    }
  };

  // 组件卸载时清除定时器
  useEffect(() => {
    return () => {
      if (autoScrollInterval.current) {
        clearInterval(autoScrollInterval.current);
      }
    };
  }, []);

  // 获取当前显示的图片
  const getCurrentImage = () => {
    if (!hoverSection) return null;

    const images = HOVER_IMAGES[hoverSection as keyof typeof HOVER_IMAGES];
    return images[imageIndex];
  };

  // 获取当前显示的图片
  const getCurrentImage1 = () => {
    if (!onclickSection) return null;

    const images = HOVER_IMAGES[onclickSection as keyof typeof HOVER_IMAGES];
    return images[imageIndex];
  };

  return (
    <section className="w-full relative px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] mx-auto gap-[10px] flex flex-col">
      {/*背景*/}
      <div className="absolute inset-0 -z-10 w-full h-full">
        <Image
          src="/bg_all_in_on_machine_05.png"
          alt="聚焦AI作业管理背景"
          fill
        />
      </div>
      {/* 主体部分 */}
      <div className="w-full max-w-[1360px] mx-auto pb-[140px] [@media(max-width:768px)]:pb-[90px] flex flex-col gap-[80px] [@media(max-width:768px)]:gap-[40px]">
        {/* 上面的div - 标题区域 */}
        <div className="w-full flex flex-col gap-[20px] mx-auto pb-[80px] pt-[80px] [@media(max-width:768px)]:pt-[60px]">
          {/* 第二部分：图片 */}
          <div className="w-[58px] h-[56px] border border-white/10 items-center justify-center hidden [@media(max-width:660px)]:flex mx-auto">
            <Image
              src="/icon5_05.png"
              alt="AI作业管理"
              width={58}
              height={56}
            />
          </div>
          <div className="flex items-center justify-center gap-3">
            {/* 第一部分：文字 */}
            <h2 className="text-[46px] [@media(min-width:415px)_and_(max-width:660px)]:text-[40px] [@media(max-width:414px)]:text-[clamp(2rem,9vw,2.5rem)] font-semibold leading-[52px] tracking-[0px] text-center text-[#333333]">
              聚焦 AI 作业管理
            </h2>
            {/* 第二部分：图片 */}
            <div className="w-[58px] h-[56px] border border-white/10 flex items-center justify-center [@media(max-width:660px)]:hidden">
              <Image
                src="/icon5_05.png"
                alt="AI作业管理"
                width={58}
                height={56}
              />
            </div>
          </div>
          {/* 第三部分：第二行文字 */}
          <p className="w-full text-[18px] [@media(max-width:660px)]:text-[14px] font-normal leading-[28px] tracking-[2px] text-center text-[#666666]">
            在个人版的基础上，拓展多样灵活进校解决方案，打通作业减负提质，助推学校精准教学、教学质量提升的数字化转型
          </p>
        </div>

        {/* 768px开始显示的图 */}
        <div className="w-full hidden [@media(max-width:768px)]:block items-center justify-center">
          <Image
            src="/homework_ai_05.png"
            alt="AI作业管理768px新增图"
            width={688}
            height={298}
          />
        </div>

        {/* 下面的div - 内容区域 */}
        <div className="w-full flex flex-row [@media(max-width:768px)]:flex-col justify-between gap-[clamp(10px,2vw,20px)] relative">
          {/* 左边部分 */}
          <div className="w-full min-h-[763px]  max-w-[700px] flex flex-col relative gap-[0px] [@media(max-width:768px)]:gap-[43px]">
            {/* 悬停图片展示区域 - 绝对定位覆盖在左边部分 */}
            {isModalOpen && (
              <div
                className="hidden fixed [@media(max-width:660px)]:flex top-0 left-0 z-[100] w-full  justify-center items-center h-full bg-[rgba(0,0,0,0.6)]"
                onClick={() => setIsModalOpen(false)}
              >
                <div className="absolute inset-0 py-[300px] w-full h-[450px] px-[20px] z-50 overflow-hidden rounded-lg transition-all duration-500 pointer-events-none">
                  <div
                    className={`w-full h-full relative ${styles.imageWrapper}`}
                  >
                    <Image
                      src={getCurrentImage1() || ""}
                      alt="悬停图片"
                      width={749}
                      height={760}
                      className={`w-full h-auto object-contain transition-opacity duration-500 ${styles.scrollContainer}`}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* 悬停图片展示区域 - 绝对定位覆盖在左边部分 */}
            {hoverSection && (
              <div className="absolute inset-0 [@media(max-width:660px)]:hidden w-full h-full z-50 overflow-hidden rounded-lg transition-all duration-500 pointer-events-none">
                <div
                  className={`w-full h-full relative ${styles.imageWrapper}`}
                >
                  <Image
                    src={getCurrentImage() || ""}
                    alt="悬停图片"
                    width={749}
                    height={760}
                    className={`w-full h-auto object-contain transition-opacity duration-500 ${styles.scrollContainer}`}
                  />
                </div>
              </div>
            )}

            {/* 左边上部分 */}
            <div className="w-full h-full flex flex-row gap-[23px] [@media(max-width:660px)]:flex-col justify-center items-stretch [@media(max-width:600px)]:items-center">
              {/* 左边上左-原卷+手写 */}
              <div
                className="h-auto flex-1 max-w-[388px] [@media(max-width:660px)]:max-w-[640px] min-w-[288px] gap-[8px] p-[30px_40px] [@media(max-width:768px)]:p-[20px_20px] rounded-[20px] bg-white flex flex-col relative z-10 transition-all duration-300 hover:shadow-lg cursor-pointer"
                onMouseEnter={() => handleMouseEnter("section1")}
                onMouseLeave={handleMouseLeave}
                onClick={handleOnClick}
                onMouseDown={() => setOnclickSection("section1")}
              >
                {/* 校园方案上左部分上div */}
                <div className="w-full gap-[8px] flex items-center">
                  {/* 图片移到标题前面 */}
                  <Image
                    src="/icon1_05.png"
                    alt="蜜蜂家校支持纸质作业采集智能批改，不改变老师、学生原有习惯"
                    width={32}
                    height={30}
                    className="[@media(max-width:660px)]:w-[24px] [@media(max-width:660px)]:h-[23px]"
                  />
                  <h3 className="w-full text-[24px] [@media(max-width:660px)]:text-[20px] font-semibold leading-[44px] tracking-[0px] text-[#333333]">
                    原卷+手写
                  </h3>
                </div>

                {/* 校园方案上左部分下div */}
                <p className="w-full text-[16px] [@media(max-width:660px)]:text-[14px] font-normal leading-[28px] tracking-[0px] text-[#666666]">
                  支持任意纸质作业采集智能批改：大单元学历案、导学单、日常作业（练习册），不改变老师教学习惯。
                  学生手写作答，无需特定纸张、特殊笔、电子终端、特殊标记，不改变学生做题习惯。
                </p>
              </div>

              {/* 左边上右-教学资源智能化 */}
              <div
                className="h-auto flex-1 max-w-[388px] [@media(max-width:660px)]:max-w-[640px] min-w-[288px] gap-[10px] p-[30px_40px] [@media(max-width:768px)]:p-[20px_20px] rounded-[20px] bg-white flex flex-col relative z-10 transition-all duration-300 hover:shadow-lg cursor-pointer"
                onMouseEnter={() => handleMouseEnter("section2")}
                onMouseLeave={handleMouseLeave}
                onClick={handleOnClick}
                onMouseDown={() => setOnclickSection("section2")}
              >
                {/* 校园方案上右部分上div */}
                <div className="w-full gap-[8px] flex items-center">
                  {/* 图片移到标题前面 */}
                  <Image
                    src="/icon2_05.png"
                    alt="蜜蜂家校教学资源智能化：采集并精细化标注"
                    width={32}
                    height={30}
                    className="[@media(max-width:660px)]:w-[24px] [@media(max-width:660px)]:h-[23px]"
                  />
                  <h3 className="w-full text-[24px] [@media(max-width:660px)]:text-[20px] font-semibold leading-[44px] tracking-[0px] text-[#333333]">
                    教学资源智能化
                  </h3>
                </div>

                {/* 校园方案上右部分下div */}
                <p className="w-full text-[16px] [@media(max-width:660px)]:text-[14px] font-normal leading-[28px] tracking-[0px] text-[#666666]">
                  云端题库，多版本覆盖全学科、全学段；
                  <br />
                  支持第三方资源入库，纸质校本资源采集并完成智能化，形成知识图谱；校本资源电子化：将练习册、试卷等进行数字化，进行精细化标注。
                </p>
              </div>
            </div>

            {/* 左边中部分 - 有重叠效果，z-index更高 */}
            <div className="-mt-[20px] max-h-[119.5px] z-30 mx-auto [@media(max-width:768px)]:hidden">
              <Image
                src="/arrowhead_top_05.png"
                alt="校园方案中部图标"
                width={95.59}
                height={119.5}
                className="object-cover"
              />
            </div>

            {/* 左边下部分 */}
            <div className="w-full h-full -mt-[20px] flex flex-row [@media(max-width:660px)]:flex-col gap-[23px] items-stretch justify-center [@media(max-width:600px)]:items-center">
              {/* 左边下左 */}
              <div
                className="flex-1 max-w-[388px] [@media(max-width:660px)]:max-w-[640px] min-w-[288px] gap-[8px] p-[30px_40px] [@media(max-width:768px)]:p-[20px_20px] rounded-[20px] bg-white flex flex-col relative z-10 transition-all duration-300 hover:shadow-lg cursor-pointer"
                onMouseEnter={() => handleMouseEnter("section3")}
                onMouseLeave={handleMouseLeave}
                onClick={handleOnClick}
                onMouseDown={() => setOnclickSection("section3")}
              >
                {/* 校园方案下左部分上div */}
                <div className="w-full gap-[8px] flex items-center">
                  {/* 图片移到标题前面 */}
                  <Image
                    src="/jiangketang_05.png"
                    alt="蜜蜂家校课堂模式：统计错题数、展示错误作答情况，方便课堂讲解"
                    width={32}
                    height={30}
                    className="[@media(max-width:660px)]:w-[24px] [@media(max-width:660px)]:h-[23px]"
                  />
                  <h3 className="w-full text-[24px] [@media(max-width:660px)]:text-[20px] font-semibold leading-[44px] tracking-[0px] text-[#333333]">
                    课堂讲评
                  </h3>
                </div>

                {/* 校园方案下左部分下div */}
                <p className="w-full text-[16px] [@media(max-width:660px)]:text-[14px] font-normal leading-[28px] tracking-[0px] text-[#666666]">
                  统计错题数、展示学生错误作答情况，课堂模式连接教室白板，方便老师课堂讲解，精讲精练，帮助学生查缺补漏，夯实基础。
                </p>
              </div>

              {/* 左边下右 */}
              <div
                className="flex-1 max-w-[388px] [@media(max-width:660px)]:max-w-[640px] min-w-[288px] gap-[8px] p-[30px_40px] [@media(max-width:768px)]:p-[20px_20px] rounded-[20px] bg-white flex flex-col relative z-10 transition-all duration-300 hover:shadow-lg cursor-pointer"
                onMouseEnter={() => handleMouseEnter("section4")}
                onMouseLeave={handleMouseLeave}
                onClick={handleOnClick}
                onMouseDown={() => setOnclickSection("section4")}
              >
                {/* 校园方案下右部分上div */}
                <div className="w-full gap-[8px] flex items-center">
                  {/* 图片移到标题前面 */}
                  <Image
                    src="/fenxi_05.png"
                    alt="蜜蜂家校学情分析：个人、阶段、校端数仓看板都支持"
                    width={32}
                    height={30}
                    className="[@media(max-width:660px)]:w-[24px] [@media(max-width:660px)]:h-[23px]"
                  />
                  <h3 className="w-full text-[24px] [@media(max-width:660px)]:text-[20px] font-semibold leading-[44px] tracking-[0px] text-[#333333]">
                    学情大数据分析
                  </h3>
                </div>

                {/* 校园方案下右部分下div */}
                <p className="w-full text-[16px] [@media(max-width:660px)]:text-[14px] font-normal leading-[28px] tracking-[0px] text-[#666666]">
                  阶段学情分析、学生个人学情、校端数舱看板
                  <br />
                  为学生提供个性化的学习建议；
                  <br />
                  为学校提供学情数据统计、分析和预警；
                  <br />
                  为教师提供更精准的教学辅助，共性问题筛选和分析。
                </p>
              </div>
            </div>
          </div>

          {/* 中间部分 */}
          <div className="relative flex justify-center items-center [@media(max-width:768px)]:hidden">
            {/* 中间上部分 - 旋转-90度 */}
            <div className="absolute top-[149.01px] left-[-40.5px] w-[95.59px] h-[119.5px] origin-center transform rotate-90 z-30">
              <Image
                src="/arrowhead_top_05.png"
                alt="校园方案中上部"
                width={95.59}
                height={119.5}
                className="object-cover"
              />
            </div>

            {/* 中间下部分 - 旋转90度 */}
            <div className="absolute top-[509.6px] left-[-30.96px] w-[95.59px] h-[119.5px] origin-center transform -rotate-90 z-30">
              <Image
                src="/arrowhead_top_05.png"
                alt="校园方案中下部"
                width={95.59}
                height={119.5}
                className="object-cover"
              />
            </div>
          </div>

          {/* 右边部分 */}
          <div
            className=" w-full max-w-[530px] flex justify-center items-center mx-auto cursor-pointer"
            onClick={() => setShowVideo(true)}
          >
            <Image
              src="/all_in_on_machine_05.png"
              alt="校园方案右部"
              width={530}
              height={760}
              className="object-contain w-full"
            />
          </div>
        </div>
      </div>
      <Modal show={showVideo} type="2" onClose={() => setShowVideo(false)} />
    </section>
  );
};

export default Campus;
